<template>
  <v-stepper-items>
    <v-stepper-content class="pa-0" step="6">
      <v-row justify="center" v-if="Object.keys(store.orderInfo).length != 0">
        <v-col cols="12" sm="10" md="8" lg="6" xl="6" align="center">
          <v-container class="py-0">
            <v-card class="card py-5 my-3">
              <h3 class="text-center mb-3" translate>
                {{ $t(["CONFIRMATION"]) }}
              </h3>

              <v-divider class="mt-3 mx-3"></v-divider>

              <v-alert
                v-model="errorMsgAlert"
                close-text="Close Alert"
                class="alert-text my-5 mx-3"
                color="error"
                dark
                dismissible
                ref="snackbarError"
                style="color: white !important"
              >
                {{ $t(errorMsg) }}
              </v-alert>

              <div
                v-show="
                  Object.keys(store.registrationInfoFormData).length != 0 &&
                  !(
                    store.orderInfo.selection == 'Register and/or Donate' ||
                    store.orderInfo.selection.includes('Registration')
                  ) &&
                  donationAmount > 0
                "
              >
                <h4 class="mt-3" translate>
                  {{ $t(["Tax Receipt Information"]) }}
                </h4>

                <v-divider class="mt-3 mx-3"></v-divider>

                <v-simple-table class="px-3">
                  <template v-slot:default>
                    <tbody>
                      <tr
                        v-for="item in store.getRegistrationInfoFormData"
                        :key="item.title"
                      >
                        <td>
                          <b>{{ $t(item.title) }}</b>
                        </td>
                        <td>
                          {{ item.value }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-divider class="mx-3"></v-divider>
              </div>

              <div
                v-show="
                  store.orderInfo.selection == 'Register and/or Donate' ||
                  store.orderInfo.selection.includes('Registration')
                "
              >
                <h4 class="mt-3" translate>
                  {{ $t(["Registration Information"]) }}
                </h4>

                <v-divider class="mt-3 mx-3"></v-divider>

                <v-simple-table class="px-3">
                  <template v-slot:default>
                    <tbody>
                      <tr
                        v-for="item in store.getRegistrationInfoFormData"
                        :key="item.title"
                      >
                        <td>
                          <b>{{ $t(item.title) }}</b>
                        </td>
                        <td>{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-divider class="mx-3"></v-divider>
              </div>

              <div v-show="total > 0">
                <h4 class="mt-3" translate>
                  {{ $t(["Payment Information"]) }}
                </h4>

                <v-divider class="mt-3 mx-3"></v-divider>

                <v-simple-table class="px-3">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>
                          <b>{{ $t(["Cardholder Name"]) }}</b>
                        </td>
                        <td>
                          {{ store.paymentInfoFormData.cardHolder }}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b>{{ $t(["Billing Postal Code"]) }}</b>
                        </td>
                        <td>
                          {{ store.paymentInfoFormData.postalCode }}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b>{{ $t(["Card Number"]) }}</b>
                        </td>
                        <td>
                          {{ maskedCardNumber() }}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b>{{ $t(["Card Expiry"]) }}</b>
                        </td>
                        <td>
                          {{ store.paymentInfoFormData.cardExpiry }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-divider class="mx-3"></v-divider>
              </div>

              <div>
                <h4 class="mt-3" translate>{{ $t(["Summary Total"]) }}</h4>

                <v-divider class="mt-3 mx-3"></v-divider>

                <v-simple-table class="px-3">
                  <template v-slot:default>
                    <tbody>
                      <tr v-show="store.orderInfo.type == 'Merchandise'">
                        <td>
                          <b translate>{{ $t(["Merchandise"]) }}</b>
                        </td>

                        <td
                          v-html="
                            $t('Currency', {
                              amount: (store.orderInfo.merchTotal != undefined
                                ? store.orderInfo.merchTotal
                                : 0
                              ).toFixed(2),
                            })
                          "
                        />
                      </tr>

                      <tr
                        v-if="
                          Object.keys(store.donationInfoFormData).length != 0
                        "
                      >
                        <td>
                          <b translate>{{ $t(["Donation"]) }}</b>
                        </td>
                        <td
                          v-html="
                            $t('Currency', {
                              amount:
                                store.donationInfoFormData.donationAmount.toFixed(
                                  2,
                                ),
                            })
                          "
                        />
                      </tr>

                      <tr>
                        <td>
                          <h3 translate>
                            {{ $t(["TOTAL"]) }}
                          </h3>
                        </td>
                        <td>
                          <h3
                            v-html="
                              $t('Currency', { amount: total.toFixed(2) })
                            "
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <v-divider class="mx-3"></v-divider>

              <p class="text-center receipt-tax-size mt-3 mx-3" translate>
                {{
                  $t([
                    "If applicable, a tax receipt will be sent at a later date",
                  ])
                }}
              </p>

              <v-row class="mt-3">
                <v-col cols="6" align="center">
                  <v-btn
                    class="btn-text"
                    large
                    :disabled="submitBtnLoading"
                    @click="previousStep()"
                  >
                    {{ $t(["Back"]) }}
                  </v-btn>
                </v-col>

                <v-col cols="6" align="center">
                  <v-btn
                    class="btn-text"
                    color="primary"
                    large
                    translate
                    :loading="submitBtnLoading"
                    @click="nextStep()"
                  >
                    {{ $t(["Submit"]) }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-show="submitBtnLoading" justify="center">
                <span class="my-2" ref="processingText">
                  <b>{{
                    $t("Processing, please do not refresh your browser")
                  }}</b>
                </span>
              </v-row>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { useFormDataStore } from "../../../store/formData.js";

export default {
  name: "S6_Confirmation",
  data: () => {
    return {
      submitBtnLoading: false,
      errorMsgAlert: false,
      errorMsg: "",
      total: 0,
    };
  },
  setup() {
    const store = useFormDataStore();

    return {
      store,
    };
  },
  props: {
    donationAmount: undefined,
    merchAmount: undefined,
  },
  watch: {
    donationAmount() {
      if (this.donationAmount != undefined) {
        this.total =
          this.donationAmount +
          (this.store.orderInfo.merchTotal != undefined
            ? this.store.orderInfo.merchTotal
            : 0);
      }
    },
    merchAmount() {
      if (this.merchAmount != undefined) {
        this.total = this.merchAmount;
      }
    },
  },
  methods: {
    async nextStep() {
      // console.log({
      //   ...this.store.donationInfoFormData,
      //   ...this.store.registrationInfoFormData,
      //   ...this.store.paymentInfoFormData,
      //   amount: this.total,f
      // });

      this.submitBtnLoading = true;

      this.$nextTick(() => {
        this.$vuetify.goTo(document.body.scrollHeight);
      });

      try {
        await axios
          .post(process.env.VUE_APP_BASE_URL_API + "form/process", {
            eventName: this.store.eventName,
            runSiteId: this.store.orderInfo.runSiteId,
            orderId: this.store.orderInfo.id,
            formData:
              this.total > 0
                ? {
                    ...this.store.donationInfoFormData,
                    ...this.store.registrationInfoFormData,
                    ...this.store.paymentInfoFormData,
                    amount: this.total,
                  }
                : this.store.orderInfo.type == "RegisterAndDonate" &&
                  this.store.orderInfo.selection.includes("Donation")
                ? {
                    ...this.store.donationInfoFormData,
                    amount: this.total,
                  }
                : {
                    ...this.store.donationInfoFormData,
                    ...this.store.registrationInfoFormData,
                    amount: this.total,
                  },
            dt: moment(new Date(Date.now())).format(),
          })
          .then((response) => {
            // console.log(response);

            this.store.setFormSubmissionData({
              status: response.data.status,
              merchantId: response.data.merchantId,
              errorMessage:
                response.data.status === "Declined"
                  ? this.$t(["Declined, try again"])
                  : this.$t([
                      "An error occurred while processing your payment. Please try again.",
                    ]),
              total: this.total,
            });

            this.$emit("formSubmitted");
          });
      } catch (error) {
        this.errorMsgAlert = true;
        this.errorMsg = error.message;

        this.$nextTick(() => {
          const el = this.$el.querySelector("snackbarError");
          this.$vuetify.goTo(-5, el);

          return;
        });
      }

      this.submitBtnLoading = false;
    },
    previousStep() {
      this.$emit("previousStepFromSix");
    },
    maskedCardNumber() {
      let cardNumber = this.store.paymentInfoFormData.cardNumber;

      if (cardNumber) {
        return `${"*".repeat(cardNumber.length - 4)}${cardNumber.substr(
          cardNumber.length - 4,
        )}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
